<template>
  <div>
      <div class="chinese-input" @click="()=>{
          this.numbershow=true;
      }">
        <span v-if="!numberInput" class="placeholder">{{placeholder}}</span>
        <span v-else>{{numberInput}}</span>
    </div>
    <div class="number-dit" v-if="numbershow" @click="()=>this.numbershow=false">
      <van-number-keyboard :show="true"
            extra-key="清空"
            @input="(value)=>xuanz(value)"
            @delete="()=>deletez()"
      />
    </div>
  </div>
</template>
<script>
  import "./number.scss";
  export default {
    name: "number",
    data(){
      return{
          numbershow:false,
          numberInput:'',
      }
    },
    props: {
        placeholder:{
            type: String,
            required: true
        },
        inputMot:{
            type: Function,
            required: true
        }
    },
    watch: {
        
    },
    methods:{
        xuanz(value){
            if(value=='清空'){
                this.numberInput='';
            }else{
                this.numberInput = this.numberInput+value;
            }
            this.inputMot(this.numberInput);
        },
        deletez(){
            if(this.numberInput.length>0){
                this.numberInput = this.numberInput.substr(0, this.numberInput.length - 1);
            }
            this.inputMot(this.numberInput);
        }
    }
  };
</script>
